import React from 'react'

import {
    Container
} from 'reactstrap'
import View from 'components/View'
import PageTitle from 'components/PageTitle'
import SubNavigation from 'components/SubNavigation'

import UserManager from 'services/UserManager'

class Login extends React.Component {
    componentDidMount() {
        UserManager.signinRedirect()
    }

    render() {
        return (
            <React.Fragment>
                <SubNavigation />
                <View>
                    <Container className="ao-dashboard">
                        <PageTitle>Login</PageTitle>
                        <p>Even wachten aub...</p>
                    </Container>
                </View>
            </React.Fragment>
        )
    }
}

export default Login
